export const DBConfig = {
    name: 'smartguide_db',
    version: 1,
    data: {
        name: "smartguide_audios", value: ""
    },
    visited: {
        name: "smartguide_visited", value: {}
    }
};